/* ThemeDrop Horizon — comportements du thème (identiques dans l'aperçu
   ThemeDrop et sur Shopify : seul le réseau /cart/*.js est simulé dans
   l'aperçu). Aucune dépendance. */
(function () {
  'use strict';

  var config = {};
  try { config = JSON.parse(document.getElementById('hz-config').textContent); } catch (e) { config = {}; }
  var routes = config.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  var moneyFormat = config.moneyFormat || '€{{amount_with_comma_separator}}';
  var freeShipping = Number(config.freeShippingThreshold) || 0;
  // Textes du thème dans la langue de la boutique (locales/*.json, via
  // hz-config dans layout/theme.liquid). Le filtre `t` de Shopify échappe le
  // HTML (d'ajouter → d&#39;ajouter) : décodé ici avant affichage.
  var strings = config.strings || {};
  function i18n(key, fallback) {
    if (!strings[key]) return fallback;
    var decoder = document.createElement('textarea');
    decoder.innerHTML = strings[key];
    return decoder.value;
  }
  var root = document.documentElement;
  var body = document.body;
  var animate = body.classList.contains('hz-animate') && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function navigate(url) {
    if (typeof window.hzNavigate === 'function') window.hzNavigate(url);
    else window.location.href = url;
  }

  // Même algorithme que le filtre Liquid `money` de Shopify.
  function formatMoney(cents, format) {
    var value = (Number(cents) || 0) / 100;
    function fmt(number, precision, thousands, decimal) {
      var parts = number.toFixed(precision).split('.');
      var int = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts[1] ? int + decimal + parts[1] : int;
    }
    return String(format || moneyFormat).replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return fmt(value, 2, ',', '.');
        case 'amount_no_decimals': return fmt(value, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(value, 0, '.', ',');
        case 'amount_with_space_separator': return fmt(value, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fmt(value, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return fmt(value, 2, "'", '.');
        default: return fmt(value, 2, ',', '.');
      }
    });
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var ICONS = {
    minus: '<svg class="hz-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12h14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    plus: '<svg class="hz-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>'
  };

  /* ── Verrouillage du scroll (menu / tiroir) ───────────────────────── */
  var locks = 0;
  function lockScroll() { locks += 1; root.classList.add('hz-lock'); }
  function unlockScroll() { locks = Math.max(0, locks - 1); if (!locks) root.classList.remove('hz-lock'); }

  /* ── Apparition au défilement ─────────────────────────────────────── */
  function initReveal() {
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-hz-reveal]'));
    if (!animate || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ── Compteurs ────────────────────────────────────────────────────── */
  function initCounters() {
    if (!animate || !('IntersectionObserver' in window)) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-hz-count]'), function (el) {
      var raw = String(el.getAttribute('data-hz-count') || '').trim();
      if (!/^\d+([.,]\d+)?$/.test(raw)) return;
      var sep = raw.indexOf(',') > -1 ? ',' : '.';
      var decimals = (raw.split(/[.,]/)[1] || '').length;
      var target = parseFloat(raw.replace(',', '.'));
      el.textContent = (0).toFixed(decimals).replace('.', sep);
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        var start = null;
        var duration = 1400;
        function step(ts) {
          if (start === null) start = ts;
          var p = Math.min(1, (ts - start) / duration);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = p < 1 ? (target * eased).toFixed(decimals).replace('.', sep) : raw;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }, { threshold: 0.4 });
      io.observe(el);
    });
  }

  /* ── En-tête ──────────────────────────────────────────────────────── */
  function initHeader() {
    var header = document.querySelector('[data-hz-header]');
    if (!header) return;
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ── Menu mobile ──────────────────────────────────────────────────── */
  var menu = document.querySelector('[data-hz-menu]');
  function openMenu() {
    if (!menu) return;
    menu.hidden = false;
    lockScroll();
    requestAnimationFrame(function () { menu.classList.add('is-open'); });
    Array.prototype.forEach.call(document.querySelectorAll('[data-hz-menu-open]'), function (b) { b.setAttribute('aria-expanded', 'true'); });
  }
  function closeMenu() {
    if (!menu || menu.hidden) return;
    menu.classList.remove('is-open');
    unlockScroll();
    Array.prototype.forEach.call(document.querySelectorAll('[data-hz-menu-open]'), function (b) { b.setAttribute('aria-expanded', 'false'); });
    setTimeout(function () { menu.hidden = true; }, 400);
  }

  /* ── Tiroir panier ────────────────────────────────────────────────── */
  var drawer = document.querySelector('[data-hz-drawer]');
  function openDrawer() {
    if (!drawer || !drawer.hidden) return;
    drawer.hidden = false;
    lockScroll();
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    unlockScroll();
    setTimeout(function () { drawer.hidden = true; }, 400);
  }

  function jsonRequest(url, payload) {
    return fetch(url, {
      method: payload ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: payload ? JSON.stringify(payload) : undefined
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }
  function fetchCart() { return jsonRequest(routes.cart + '.js'); }

  function lineHtml(item) {
    var title = escapeHtml(item.product_title);
    var url = escapeHtml(item.url);
    var variant = item.variant_title && !item.product_has_only_default_variant ? '<p class="hz-line__variant">' + escapeHtml(item.variant_title) + '</p>' : '';
    var was = item.original_line_price > item.final_line_price ? ' <s>' + formatMoney(item.original_line_price) + '</s>' : '';
    var key = escapeHtml(item.key);
    return '<li class="hz-line">' +
      '<a class="hz-line__media" href="' + url + '">' + (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="" width="160" height="160" loading="lazy">' : '') + '</a>' +
      '<div class="hz-line__info">' +
        '<a class="hz-line__title" href="' + url + '">' + title + '</a>' + variant +
        '<p class="hz-line__price">' + formatMoney(item.final_line_price) + was + '</p>' +
        '<div class="hz-line__row">' +
          '<div class="hz-qty hz-qty--sm">' +
            '<button type="button" data-hz-line="' + key + '" data-hz-line-qty="' + (item.quantity - 1) + '" aria-label="' + escapeHtml(i18n('removeOne', 'Retirer un article')) + '">' + ICONS.minus + '</button>' +
            '<span class="hz-qty__value" aria-live="polite">' + item.quantity + '</span>' +
            '<button type="button" data-hz-line="' + key + '" data-hz-line-qty="' + (item.quantity + 1) + '" aria-label="' + escapeHtml(i18n('addOne', 'Ajouter un article')) + '">' + ICONS.plus + '</button>' +
          '</div>' +
          '<button type="button" class="hz-line__remove" data-hz-line="' + key + '" data-hz-line-qty="0">' + escapeHtml(i18n('remove', 'Retirer')) + '</button>' +
        '</div>' +
      '</div>' +
    '</li>';
  }

  function renderCart(cart) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-hz-cart-count]'), function (el) {
      var changed = el.textContent !== String(cart.item_count);
      el.textContent = cart.item_count;
      el.classList.toggle('is-empty', cart.item_count === 0);
      if (changed && cart.item_count > 0) {
        el.classList.remove('is-bump');
        void el.offsetWidth;
        el.classList.add('is-bump');
      }
    });
    if (!drawer) return;
    var lines = drawer.querySelector('[data-hz-lines]');
    var empty = drawer.querySelector('[data-hz-empty]');
    var foot = drawer.querySelector('[data-hz-foot]');
    var count = drawer.querySelector('[data-hz-drawer-count]');
    var subtotal = drawer.querySelector('[data-hz-subtotal]');
    if (count) count.textContent = '(' + cart.item_count + ')';
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    if (lines) lines.innerHTML = cart.items.map(lineHtml).join('');
    if (empty) empty.hidden = cart.item_count > 0;
    if (foot) foot.hidden = cart.item_count === 0;

    var ship = drawer.querySelector('[data-hz-ship]');
    if (ship) {
      ship.hidden = !(freeShipping > 0 && cart.item_count > 0);
      var text = ship.querySelector('[data-hz-ship-text]');
      var fill = ship.querySelector('[data-hz-ship-fill]');
      var remaining = freeShipping - cart.total_price;
      var pct = freeShipping > 0 ? Math.min(100, Math.round(cart.total_price / freeShipping * 100)) : 0;
      if (text) {
        text.textContent = remaining > 0
          ? String(text.getAttribute('data-template-remaining') || '').replace('[montant]', formatMoney(remaining)).replace('[amount]', formatMoney(remaining))
          : String(text.getAttribute('data-template-done') || '');
      }
      ship.classList.toggle('is-done', remaining <= 0);
      if (fill) fill.style.width = pct + '%';
    }
  }

  function refreshCart() { return fetchCart().then(renderCart); }

  function setBusy(button, busy) {
    if (!button) return;
    button.disabled = busy;
    button.classList.toggle('is-busy', busy);
  }

  function addFromForm(form, button, thenFn) {
    var data = new FormData(form);
    var id = Number(data.get('id'));
    var quantity = Math.max(1, Number(data.get('quantity')) || 1);
    var error = form.querySelector('[data-hz-form-error]');
    if (error) error.hidden = true;
    setBusy(button, true);
    return jsonRequest(routes.cartAdd + '.js', { items: [{ id: id, quantity: quantity }] })
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        renderCart(cart);
        setBusy(button, false);
        if (thenFn) thenFn(cart);
      })
      .catch(function (err) {
        setBusy(button, false);
        if (error) {
          error.textContent = (err && (err.description || err.message)) || i18n('addError', "Impossible d'ajouter ce produit.");
          error.hidden = false;
        }
      });
  }

  /* ── Galerie produit (glisser + vignettes + points) ───────────────── */
  function initGalleries() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-hz-gallery]'), function (gallery) {
      var track = gallery.querySelector('[data-hz-gallery-track]');
      if (!track) return;
      var thumbs = gallery.querySelectorAll('[data-hz-gallery-thumb]');
      var dots = gallery.querySelectorAll('[data-hz-gallery-dot]');
      function setActive(index) {
        Array.prototype.forEach.call(thumbs, function (t, i) { t.classList.toggle('is-active', i === index); });
        Array.prototype.forEach.call(dots, function (d, i) { d.classList.toggle('is-active', i === index); });
      }
      function goTo(index) { track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' }); }
      // Demande venant du sélecteur de variantes : afficher la photo de la variante.
      gallery.addEventListener('hz:goto', function (event) { goTo(event.detail); });
      Array.prototype.forEach.call(thumbs, function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
      Array.prototype.forEach.call(dots, function (d, i) { d.addEventListener('click', function () { goTo(i); }); });
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          setActive(Math.round(track.scrollLeft / Math.max(1, track.clientWidth)));
        });
      }, { passive: true });
    });
  }

  /* ── Échange d'image (produit vedette) ────────────────────────────── */
  function initSwaps() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-hz-swap]'), function (wrap) {
      var target = wrap.querySelector('[data-hz-swap-target]');
      var buttons = wrap.querySelectorAll('[data-hz-swap-src]');
      Array.prototype.forEach.call(buttons, function (btn) {
        btn.addEventListener('click', function () {
          if (target) target.src = btn.getAttribute('data-hz-swap-src');
          Array.prototype.forEach.call(buttons, function (b) { b.classList.toggle('is-active', b === btn); });
        });
      });
    });
  }

  /* ── Sélecteur de quantité ────────────────────────────────────────── */
  function initQuantity() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-hz-qty]'), function (wrap) {
      var input = wrap.querySelector('input');
      if (!input) return;
      Array.prototype.forEach.call(wrap.querySelectorAll('[data-hz-qty-step]'), function (btn) {
        btn.addEventListener('click', function () {
          var next = Math.max(1, Math.min(99, (Number(input.value) || 1) + Number(btn.getAttribute('data-hz-qty-step'))));
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ── Sélecteur de variantes (fiche produit) ───────────────────────── */
  // Présent seulement si le produit a plusieurs variantes (voir
  // hz-main-product.liquid). À chaque choix : identifiant envoyé au panier,
  // prix, réduction, disponibilité, boutons, barre collante, photo, URL.
  function priceHtml(v) {
    var html = '<span class="hz-price__now">' + formatMoney(v.price) + '</span>';
    if (v.compare_at_price > v.price) {
      var pct = Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price);
      html += '<s class="hz-price__was">' + formatMoney(v.compare_at_price) + '</s><span class="hz-price__badge">-' + pct + '%</span>';
    }
    return html;
  }

  function initVariants() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-hz-variants]'), function (picker) {
      var variants = [];
      try { variants = JSON.parse(picker.querySelector('[data-hz-variants-json]').textContent) || []; } catch (e) { return; }
      var groups = picker.querySelectorAll('[data-hz-option-group]');

      function selectedValues() {
        return Array.prototype.map.call(groups, function (group) {
          var select = group.querySelector('select');
          if (select) return select.value;
          var checked = group.querySelector('input:checked');
          return checked ? checked.value : null;
        });
      }
      function find(values) {
        for (var i = 0; i < variants.length; i += 1) {
          var v = variants[i];
          var match = (v.options || []).every(function (opt, j) { return opt === values[j]; });
          if (match) return v;
        }
        return null;
      }
      // Barre les valeurs qui, avec les autres choix actuels, ne mènent à
      // aucune variante disponible (elles restent cliquables).
      function markAvailability(values) {
        Array.prototype.forEach.call(groups, function (group, i) {
          Array.prototype.forEach.call(group.querySelectorAll('input, option'), function (el) {
            var test = values.slice(); test[i] = el.value;
            var v = find(test);
            var ok = !!(v && v.available);
            var target = el.tagName === 'OPTION' ? el : el.closest('.hz-swatch');
            if (target) target.classList.toggle('is-unavailable', !ok);
          });
        });
      }

      // fromUser : faux au chargement (ni défilement de la galerie, ni URL modifiée).
      function update(fromUser) {
        var values = selectedValues();
        Array.prototype.forEach.call(groups, function (group, i) {
          var label = group.querySelector('[data-hz-option-label]');
          if (label) label.textContent = values[i] || '';
        });
        markAvailability(values);
        var variant = find(values);
        var available = !!(variant && variant.available);

        if (variant) {
          Array.prototype.forEach.call(document.querySelectorAll('[data-hz-variant-id]'), function (input) { input.value = variant.id; });
          var price = document.querySelector('[data-hz-price] .hz-price');
          if (price) price.innerHTML = priceHtml(variant);
          var save = document.querySelector('[data-hz-save]');
          if (save) {
            var saving = variant.compare_at_price > variant.price;
            save.hidden = !saving;
            var amount = save.querySelector('[data-hz-save-amount]');
            if (saving && amount) amount.textContent = formatMoney(variant.compare_at_price - variant.price);
          }
          var stickyPrice = document.querySelector('[data-hz-sticky-price]');
          if (stickyPrice) {
            stickyPrice.innerHTML = formatMoney(variant.price) + (variant.compare_at_price > variant.price ? ' <s>' + formatMoney(variant.compare_at_price) + '</s>' : '');
          }
          if (fromUser && variant.featured_media && variant.featured_media.position) {
            var gallery = document.querySelector('[data-hz-gallery]');
            if (gallery) gallery.dispatchEvent(new CustomEvent('hz:goto', { detail: variant.featured_media.position - 1 }));
          }
          if (fromUser && window.history && window.history.replaceState) {
            try {
              var url = new URL(window.location.href);
              url.searchParams.set('variant', variant.id);
              window.history.replaceState(null, '', url.toString());
            } catch (e) { /* URL non modifiable (aperçu) */ }
          }
        }

        var stock = document.querySelector('[data-hz-stock]');
        if (stock) {
          stock.classList.toggle('is-out', !available);
          var text = stock.querySelector('[data-hz-stock-text]');
          if (text) text.textContent = !variant ? i18n('unavailable', 'Combinaison indisponible') : stock.getAttribute(available ? 'data-in' : 'data-out');
        }
        Array.prototype.forEach.call(document.querySelectorAll('[data-hz-variant-atc]'), function (btn) { btn.disabled = !available; });
        var atcLabel = document.querySelector('[data-hz-atc-label]');
        var atc = document.querySelector('[data-hz-main-atc]');
        if (atcLabel && atc) atcLabel.textContent = available ? atc.getAttribute('data-label') : i18n('soldOut', 'Épuisé');
        var buyNow = document.querySelector('[data-hz-buy-now-variant]');
        if (buyNow) buyNow.hidden = !available;
      }

      picker.addEventListener('change', function () { update(true); });
      update(false);
    });
  }

  /* ── Barre d'achat collante ───────────────────────────────────────── */
  function initSticky() {
    var sticky = document.querySelector('[data-hz-sticky]');
    var anchor = document.querySelector('[data-hz-main-atc]');
    if (!sticky || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      body.classList.toggle('hz-has-sticky', show);
    });
    io.observe(anchor);
    var trigger = sticky.querySelector('[data-hz-sticky-add]');
    var form = document.getElementById(sticky.getAttribute('data-hz-sticky'));
    if (trigger && form) {
      trigger.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.querySelector('[type="submit"]').click();
      });
    }
  }

  /* ── Délégation d'événements ──────────────────────────────────────── */
  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!(t instanceof Element)) return;

    if (t.closest('[data-hz-menu-open]')) { event.preventDefault(); openMenu(); return; }
    if (t.closest('[data-hz-menu-close]') && !t.closest('a')) { event.preventDefault(); closeMenu(); return; }

    var cartOpen = t.closest('[data-hz-cart-open]');
    if (cartOpen && drawer && !body.classList.contains('hz-page-cart')) {
      event.preventDefault();
      closeMenu();
      refreshCart();
      openDrawer();
      return;
    }
    if (t.closest('[data-hz-drawer-close]')) {
      if (!t.closest('a')) event.preventDefault();
      closeDrawer();
      return;
    }

    var lineBtn = t.closest('[data-hz-line]');
    if (lineBtn) {
      event.preventDefault();
      lineBtn.disabled = true;
      var qty = Math.max(0, Number(lineBtn.getAttribute('data-hz-line-qty')) || 0);
      jsonRequest(routes.cartChange + '.js', { id: lineBtn.getAttribute('data-hz-line'), quantity: qty })
        .then(function (cart) {
          if (lineBtn.hasAttribute('data-hz-cart-page')) navigate(routes.cart);
          else renderCart(cart);
        })
        .catch(function () { lineBtn.disabled = false; });
      return;
    }

    var buyNow = t.closest('[data-hz-buy-now]');
    if (buyNow) {
      event.preventDefault();
      var buyForm = document.getElementById(buyNow.getAttribute('data-hz-buy-now'));
      if (buyForm) addFromForm(buyForm, buyNow, function () { navigate('/checkout'); });
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-hz-product-form')) return;
    event.preventDefault();
    addFromForm(form, event.submitter || form.querySelector('[type="submit"]'), function () { openDrawer(); });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    closeDrawer();
    closeMenu();
  });

  initReveal();
  initCounters();
  initHeader();
  initGalleries();
  initSwaps();
  initQuantity();
  initVariants();
  initSticky();
  if (drawer) refreshCart();
})();
